<template>
  <div class="licensing-banner">
    <div class="licensing-banner__container">
      <div class="licensing-banner__card" data-test-id="licensing-banner-card">
        <div class="licensing-banner__main">
          <p class="licensing-banner__text-main">{{ $t('licensing.banner.text') }}</p>

          <div id="licensing-banner__buttons" class="licensing-banner__buttons">
            <LicenseTrialAction v-if="canHaveTrial" id="license-trial-link" color="grey" />

            <LicenseUpgradeAction id="license-upgrade-link" />
          </div>

          <Btn @click="closeBanner" color="ghost" icon data-test-id="licensing-banner-close-button">
            <CloseIcon />
          </Btn>
        </div>
        <p class="licensing-banner__text-extra">{{ $t('licensing.text.training') }}</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import CloseIcon from '@/components/Icons/CloseIcon.vue';
import LicenseTrialAction from '@components/license/LicenseTrialAction.vue';
import LicenseUpgradeAction from '@components/license/LicenseUpgradeAction.vue';
import { LinkEvent, TrackingProperty } from '@/tracking/trackingTypes';

export default defineComponent({
  emits: { close: null },
  name: 'LicensingBanner',

  components: {
    CloseIcon,
    LicenseTrialAction,
    LicenseUpgradeAction,
  },

  methods: {
    closeBanner() {
      this.$emit('close');
    },
  },

  computed: {
    ...mapState('user', ['canHaveTrial']),
  },

  mounted() {
    this.$tracker.trackLinks('#license-trial-link', LinkEvent.LicenseTrialLinkClicked, {
      [TrackingProperty.Location]: 'LicensingBanner',
    });
    this.$tracker.trackLinks('#license-upgrade-link', LinkEvent.LicenseUpgradeLinkClicked, {
      [TrackingProperty.Location]: 'LicensingBanner',
    });
  },
});
</script>

<style lang="scss">
@use 'settings/colors';
@use 'settings/settings';
@use 'mixins/typography';
.licensing-banner__container {
  position: fixed;
  left: 0;
  right: 0;
  pointer-events: none;
  z-index: 900;
  bottom: 40px;
  top: auto;
  display: flex;
  justify-content: center;
}

.licensing-banner__card {
  border-radius: settings.$border-radius;
  box-shadow: settings.$box-shadow-layer-2;
  background: colors.$color-white;
  min-height: 68px;
  padding: 16px;
  pointer-events: all;
  min-width: 720px;
  margin: auto;
  max-width: 85vw;
}

.licensing-banner__main {
  display: grid;
  grid-template-columns: auto min-content min-content;
  grid-column-gap: 16px;
  align-items: center;
}

.licensing-banner__text-main {
  padding-right: 32px;
  margin: 0;

  @include typography.typography-16-medium(24px);
  @include typography.typography-ellipsis;
  @include typography.typography-baseline-alignment;
}

.licensing-banner__text-extra {
  margin: 0;
  margin-top: 12px;

  @include typography.typography-15-normal(150%);
}

.licensing-banner__buttons {
  display: grid;
  grid-auto-flow: column;
  grid-column-gap: 8px;
}
</style>
